import * as ReactDOMClient from 'react-dom/client';
import { useMemo } from 'react';
import { HashRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import Search from '../app/screens/Search';
import Bookmarks from '../app/screens/Bookmarks';
import { tokenKey } from '../app/config/axios';
import { AuthProvider } from 'react-auth-kit';
var rootElement = document.getElementById('search');
var root = ReactDOMClient.createRoot(rootElement);
/**
 * This is the main thing you need to use to adapt the react-router v6
 * API to what use-query-params expects.
 *
 * Pass this as the `ReactRouterRoute` prop to QueryParamProvider.
 */
var RouteAdapter = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var location = useLocation();
    var adaptedHistory = useMemo(function () { return ({
        replace: function (location) {
            navigate(location, { replace: true, state: location.state });
        },
        push: function (location) {
            navigate(location, { replace: false, state: location.state });
        },
    }); }, [navigate]);
    return children({ history: adaptedHistory, location: location });
};
root.render(<HashRouter>
    <AuthProvider authName={tokenKey} authType="localstorage">
      <QueryParamProvider ReactRouterRoute={RouteAdapter}>
        <Routes>
          <Route path="/" element={<Search />}/>
          <Route path="/favoris" element={<Bookmarks />}/>
        </Routes>
      </QueryParamProvider>
    </AuthProvider>
  </HashRouter>);
